export default __webpack_public_path__ + "static/media/sdh_tnc.bad952a0.pdf";